import {Type, Dom} from 'main.core';
import {ProfileComponent} from "./profilecomponent.js";
import {EventEmitter} from "main.core.events";

EventEmitter.subscribe(
   EventEmitter.GLOBAL_TARGET,
   "BX.UI.EntityEditor:onInit",
   function(event)
   {
		if ( event.getTarget().uniquePopupId == "intranet-user-profile" )
		{
			BX.cleanNode(event.getTarget().popupContainer.querySelector(".menu-popup-items .menu-popup-item:last-child"), true);
			return;
		}

		let [entityEditor, context] = event.getData();

		let profileFieldsNode = document.querySelector('.intranet-user-profile-column-right .ui-entity-editor-container');

		if ( Type.isDomNode(profileFieldsNode) )
		{
			let rootNode = Dom.create('div');
			Dom.append(rootNode, profileFieldsNode);

			ProfileComponent.init({
				rootNode: rootNode,
				userId: entityEditor.getEntityId()
			});
		}
   }
);

export {
	ProfileComponent
}